module.exports = "/images/zink-it-comprehensive-and-one-score.png?c6ef1a330f4b9e0b8809b5a00872c77a";